import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import { useDispatch, useSelector } from "react-redux";
import { ProjectCount } from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const ProjectCard = () => {
  const dispatch = useDispatch();
  const companyId = window.localStorage.getItem("companyid");

  const [currentProjectCount, setCurrentProjectCount] = useState([]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || key;

  const weeklyProjectCount = useSelector(
    (state) => state.user.weeklyProjectCount
  );

  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
    dispatch(ProjectCount(companyId));
  }, []);

  useEffect(() => {
    if (weeklyProjectCount.status === true) {
      setCurrentProjectCount(weeklyProjectCount.data);
    } else {
      // setApimessage(weeklyProjectCount?.message);
    }
  }, [weeklyProjectCount]);

  return (
    <>
      <div className="projectCard project_card_res">
        <div className="cardTitle">
          <div>
            <span>
              {/* Projects */}
              {t("Projects")}
            </span>
            <span> | </span>
            <span>
              {/* WEEK  */}
              {t("WEEK")}
              <text>{currentProjectCount[2]?.split(":")[1]}</text>
            </span>
          </div>
          <div className="colorDiv">
            <div>
              <div className="coloredDot"></div>
              {/* This Week */}
              {t("This Week")}
            </div>
            <div>
              <div className="coloredDotG"></div>
              {/* Last Week */}
              {t("Last Week")}
            </div>
          </div>
        </div>
        <div className="graphDisplay px-4" id="ascSelectBox">
          {currentProjectCount[3]?.map((info, index) => {
            // let modifiedInfo = { ...info, current_week_project: 10 }; // Creating a new object with current_week_project set to 10
            return (
              <div key={index} className="graph">
                <div className="graphName">{info.statusname}</div>
                <div className="stats">
                  <div
                    // className="thisWeekBar"
                    // style={{
                    //   height: `${info.projectcount + 2}rem`,
                    // }}

                    className={
                      info.projectcount === 0
                        ? "thisWeekBar0 pb-3"
                        : "thisWeekBar pb-3"
                    }
                    style={{
                      height:
                        info?.projectcount === 0
                          ? `${1}em`
                          : `${info.projectcount}em`,
                    }}
                  >
                    {info.projectcount}
                  </div>

                  <div
                    className={
                      currentProjectCount[1][index].projectcount === 0
                        ? "lastWeekBar0 pb-3"
                        : "lastWeekBar pb-3"
                    }
                    style={{
                      height:
                        currentProjectCount[1][index].projectcount === 0
                          ? `${1}em`
                          : `${currentProjectCount[1][index].projectcount}em`,
                    }}
                  >
                    {currentProjectCount[1][index].projectcount}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ProjectCard;
